module.exports = __webpack_public_path__ + "static/media/border.5904d9f0.svg";